module.exports = __webpack_public_path__ + "img/amanali-regalo.e5c287da.png";